/**
 * Status des paiements des factures
 */

export const StatutPaiementFactureKeys = {
    A_REGLER: "A_REGLER",
    REGLEE: "REGLEE",
    NON_RENSEIGNE: "NON_RENSEIGNE",
}

export const StatutPaiementFactureText = {
    [StatutPaiementFactureKeys.A_REGLER]: "À régler",
    [StatutPaiementFactureKeys.REGLEE]: "Réglée",
    [StatutPaiementFactureKeys.NON_RENSEIGNE]: "Non renseigné",
}

export const StatutPaiementFactureOptions = [
    {key: 0, value: StatutPaiementFactureKeys.A_REGLER, text: StatutPaiementFactureText.A_REGLER},
    {key: 1, value: StatutPaiementFactureKeys.REGLEE, text: StatutPaiementFactureText.REGLEE},
    {key: 3, value: StatutPaiementFactureKeys.NON_RENSEIGNE, text: StatutPaiementFactureText.NON_RENSEIGNE},
]
